var _path, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddWithDataButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24H12H12C16.9997 24 19.4995 24 21.2519 22.7268C21.8179 22.3156 22.3156 21.8179 22.7268 21.2519C24 19.4995 24 16.9997 24 12V12V12C24 7.00035 24 4.50053 22.7268 2.7481C22.3156 2.18213 21.8179 1.68442 21.2519 1.27322C19.4995 0 16.9996 0 12 0C7.00036 0 4.50054 0 2.7481 1.27322C2.18213 1.68442 1.68442 2.18213 1.27322 2.7481C0 4.50054 0 7.00036 0 12C0 16.9996 0 19.4995 1.27322 21.2519C1.68442 21.8179 2.18213 22.3156 2.7481 22.7268C4.50053 24 7.00035 24 12 24Z",
    fill: "#23BBEF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.6364,
    y: 7,
    width: 6.36364,
    height: 6.36364,
    rx: 1,
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4647 10.6364H8C7.44772 10.6364 7 11.0841 7 11.6364V16C7 16.5523 7.44772 17 8 17H12.3636C12.9159 17 13.3636 16.5523 13.3636 16V13.5628",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWithDataButton);
export default __webpack_public_path__ + "static/media/add-with-data-button.b99a22e1ae898bfdaf1a58ac8b7ac7e8.svg";
export { ForwardRef as ReactComponent };